export default {
  meta: {
    title: '转化率洞察报告'
  }
};
